import "./App.css";
import React, {useEffect} from "react";
import Header from "./ResponsiveAppBar";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import FAQ from "./Components/FAQ";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import QR from "./Components/QR";
import {useAppContext} from "./Context";
import {InitializePusher} from "./Pusher";
import {useParams} from "react-router-dom";
import {Helmet} from "react-helmet";
import {useTranslation} from "react-i18next";
import Favicon from "react-favicon";

const APP_CONFIGS = {
    luna: {
        logo: (
            <svg viewBox="0 0 617 162" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M205.36 34.09H227.9V100.24H263.66V120.55H205.36V34.09Z"
                    fill="white"
                />
                <path
                    d="M299.81 34.09H322.35V85.57C322.35 95.4 328.77 101.42 338.07 101.42C347.37 101.42 353.79 95.42 353.79 85.57V34.09H376.32V83.87C376.32 106.66 359.94 122.12 338.07 122.12C316.2 122.12 299.81 106.92 299.81 83.87V34.09Z"
                    fill="white"
                />
                <path
                    d="M495.92 34.09V122.09H488.71L441.82 76.67V120.55H419.29V32.55H426.49L473.39 77.35V34.09H495.92Z"
                    fill="white"
                />
                <path
                    d="M589.45 113.34H558.45L555.3 120.55H531.03L570.33 32.55H577.53L616.83 120.55H592.6L589.45 113.34ZM574 75.22L566.4 95.22H581.46L574 75.22Z"
                    fill="white"
                />
                <path
                    d="M162.36 81.45C162.29 125.69 125.87 161.15 80.58 161.06C36.1 160.99 0.0999933 124.87 0.169993 80.39V80.35C0.269993 36.66 37.04 0.839998 81.68 0.939998C126.32 1.04 162.43 37.08 162.36 81.45Z"
                    fill="url(#paint0_linear_1_46)"
                />
                <path
                    d="M52.17 97.72C41.72 98.12 33.89 89.82 34.32 78.89C34.8 66.78 42.32 57.09 55.25 56.83C65.77 56.62 73.54 65.34 73.92 76.15C74.29 85.73 63.22 98.94 52.17 97.72Z"
                    fill="url(#paint1_linear_1_46)"
                />
                <path
                    d="M130.62 67.14C137.62 66.95 142.28 72.59 143.92 79.31C145.21 84.63 142.92 90 139.1 91.93C134.21 94.4 129.1 93.48 124.72 89.52C120.61 85.83 118.14 81.6 119.39 75.92C120.6 70.45 124.89 67.12 130.62 67.14Z"
                    fill="url(#paint2_linear_1_46)"
                />
                <path
                    d="M88.73 40.08C83.63 40.21 79.39 36.18 79.25 31.08V30.67C79.33 26.28 84.19 22.04 89.1 22.08C94 22.02 98.02 25.93 98.1 30.83V31.22C98.09 36.62 94.42 40.08 88.73 40.08Z"
                    fill="url(#paint3_linear_1_46)"
                />
                <path
                    d="M52.73 38.78C54.58 38.73 55.88 39.41 56.01 41.12C56.15 43.01 54.67 43.98 53.01 44.12C51.56 44.21 50.3 43.14 50.17 41.69C50.17 41.61 50.17 41.54 50.17 41.46C50.01 40.15 50.95 38.96 52.26 38.8H52.27C52.42 38.78 52.58 38.77 52.73 38.78Z"
                    fill="url(#paint4_linear_1_46)"
                />
                <path
                    d="M104.94 66.02C103.36 65.98 102.06 64.75 101.94 63.17C101.83 62.37 101.72 61.37 102.59 60.97C104.01 60.32 103.51 61.81 103.94 62.28C104.37 62.75 105.22 63.22 105.81 63.74C106.23 64.12 106.94 64.46 106.6 65.22C106.26 65.98 105.74 66.01 104.94 66.02Z"
                    fill="url(#paint5_linear_1_46)"
                />
                <path
                    d="M41.04 42.76C42.19 42.97 43.04 43.45 42.97 44.76C42.98 45.93 42.05 46.88 40.88 46.89C39.71 46.9 38.76 45.97 38.75 44.81C38.68 43.37 39.94 43.08 41.04 42.76Z"
                    fill="url(#paint6_linear_1_46)"
                />
                <path d="M37.29 131.76L37.94 132.39L37.29 131.76Z" fill="#63799E"/>
                <path d="M37.29 131.76L37.94 132.39L37.29 131.76Z" fill="#63799E"/>
                <path
                    d="M155.74 70.85C156.1 76.41 153.74 81.29 151.63 86.19C147.21 96.6 140.53 105.91 132.08 113.43C130.7 114.67 129.72 115.76 128.26 113.11C126.8 110.46 121.89 110.55 119.26 112.7C116.96 114.32 116.42 117.5 118.04 119.79C118.3 120.16 118.61 120.49 118.95 120.78C120.12 121.91 119.88 122.3 118.74 122.99C112.61 126.52 106.03 129.2 99.17 130.94C97.75 131.33 97.58 130.43 97.59 129.39C97.69 119.21 89.08 113.2 82.41 112.49C70.1 111.18 62.77 118.34 60.12 126.49C59.68 127.82 60.96 130.02 58.76 130.39C57.47 130.61 55.97 129.78 54.59 129.39C51.22 128.32 47.94 126.98 44.78 125.39C43.97 124.99 42.01 123.72 39.47 122.39C31.8 118.39 25.74 112.39 19.82 106.26C18.82 105.26 18.25 104.45 19.59 103.26C20.93 102.07 20.59 100.66 19.85 99.26C19.25 97.82 17.68 97.04 16.17 97.43C13.99 98.08 13.28 97.01 12.27 95.43C9.90001 91.94 8.49001 87.94 6.63001 84.09C5.30001 81.4 6.17001 78.4 6.17001 75.54C6.17001 74.54 7.00001 74.27 7.90001 74.14C14.03 73.25 18.06 69.79 19.47 63.91C20.88 58.03 19.02 53.14 14.17 49.38C13.91 49.21 13.66 49.03 13.43 48.82C13.43 48.31 14.63 46.82 14.68 46.31C16.76 44.74 15.93 44.85 16.46 44.16C20.86 38.53 25.96 33.49 31.64 29.16C44.02 19.46 59.07 13.77 74.78 12.86C112.18 10.25 146.16 34.6 155.71 70.86H155.74V70.85ZM52.17 97.71C63.17 98.92 74.25 85.71 73.92 76.14C73.54 65.33 65.77 56.61 55.25 56.82C42.31 57.07 34.81 66.82 34.32 78.89C33.93 89.8 41.77 98.11 52.17 97.71ZM130.62 67.13C124.89 67.13 120.62 70.44 119.39 75.91C118.14 81.59 120.61 85.82 124.72 89.5C129.14 93.5 134.21 94.39 139.1 91.92C142.91 89.99 145.21 84.62 143.92 79.3C142.28 72.58 137.64 66.94 130.62 67.13ZM88.73 40.07C94.42 40.07 98.09 36.61 98.14 31.22C98.28 26.32 94.42 22.23 89.52 22.09H89.11C84.21 22.09 79.34 26.29 79.26 30.68C79.16 35.76 83.18 39.96 88.26 40.08H88.73V40.07ZM52.73 38.76C51.43 38.67 50.3 39.63 50.17 40.92C50.16 41.08 50.16 41.24 50.17 41.4C50.17 42.87 51.37 44.06 52.84 44.06H53.08C54.69 43.93 56.17 42.96 56.08 41.06C55.95 39.35 54.65 38.68 52.8 38.72L52.73 38.76ZM104.94 66C105.74 66 106.36 65.83 106.64 65.2C106.92 64.57 106.28 64.1 105.85 63.72C105.27 63.2 104.51 62.84 103.98 62.27C103.45 61.7 104.05 60.27 102.64 60.95C101.77 61.35 101.88 62.35 101.99 63.15C102.1 64.73 103.4 65.97 104.99 66H104.94ZM41.04 42.75C39.94 43.06 38.68 43.35 38.74 44.75C38.83 45.92 39.85 46.79 41.02 46.69C42.08 46.61 42.91 45.75 42.97 44.7C42.97 43.41 42.19 42.93 41.04 42.7V42.75Z"
                    fill="url(#paint7_linear_1_46)"
                />
                <path
                    d="M155.74 70.85C146.18 34.6 112.21 10.25 74.81 12.85C59.1 13.75 44.05 19.44 31.67 29.15C26.06 33.6 21.04 38.75 16.73 44.47C16.2 45.16 15.16 46.23 14.73 46.27C25.39 26.47 41.85 13.74 63.84 8.72999C106.67 -1.04001 147.06 25.18 155.54 67.73C155.67 68.76 155.74 69.81 155.74 70.85Z"
                    fill="#E3EBF7"
                />
                <defs>
                    <linearGradient
                        id="paint0_linear_1_46"
                        x1="80.8651"
                        y1="1.5617"
                        x2="80.8651"
                        y2="161.071"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#6F89FC"/>
                        <stop offset="0.78" stopColor="#57C8FD"/>
                        <stop offset="1" stopColor="#75DCFE"/>
                    </linearGradient>
                    <linearGradient
                        id="paint1_linear_1_46"
                        x1="54.008"
                        y1="58.746"
                        x2="54.008"
                        y2="99.5574"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#46A5FC"/>
                        <stop offset="1" stopColor="#42B7FD"/>
                    </linearGradient>
                    <linearGradient
                        id="paint2_linear_1_46"
                        x1="131.794"
                        y1="67.5076"
                        x2="131.794"
                        y2="93.5644"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#41AAFC"/>
                        <stop offset="1" stopColor="#3FB5FD"/>
                    </linearGradient>
                    <linearGradient
                        id="paint3_linear_1_46"
                        x1="88.77"
                        y1="21.4548"
                        x2="88.77"
                        y2="39.372"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#6192FC"/>
                        <stop offset="1" stopColor="#559BFC"/>
                    </linearGradient>
                    <linearGradient
                        id="paint4_linear_1_46"
                        x1="53.0498"
                        y1="37.2835"
                        x2="53.0498"
                        y2="42.607"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#559BFC"/>
                        <stop offset="1" stopColor="#519DFC"/>
                    </linearGradient>
                    <linearGradient
                        id="paint5_linear_1_46"
                        x1="104.31"
                        y1="59.6652"
                        x2="104.31"
                        y2="64.8564"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#45A5FC"/>
                        <stop offset="1" stopColor="#42A6FC"/>
                    </linearGradient>
                    <linearGradient
                        id="paint6_linear_1_46"
                        x1="40.852"
                        y1="41.495"
                        x2="40.852"
                        y2="45.59"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#519DFC"/>
                        <stop offset="1" stopColor="#509EFC"/>
                    </linearGradient>
                    <linearGradient
                        id="paint7_linear_1_46"
                        x1="80.05"
                        y1="12.2182"
                        x2="80.05"
                        y2="130.142"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#92B7FD"/>
                        <stop offset="0.5" stopColor="#74CAFD"/>
                        <stop offset="1" stopColor="#89DCFE"/>
                    </linearGradient>
                </defs>
            </svg>
        ),
        name: "Luna",
        api: "https://api.lunatracker.co",
        url: "https://lunatracker.co",
        faq: [
            {
                question: "faq.question1",
                answer: "faq.answer1",
            },
            {
                question: "faq.question2",
                answer: "faq.answer2",
            },
            {
                question: "faq.question3",
                answer: "faq.answer3",
            },
            {
                question: "faq.question4",
                answer: "faq.answer4",
            },
            {
                question: "faq.question5",
                answer: "faq.answer5",
            },
            {
                question: "faq.question6",
                answer: "faq.answer6",
            },
            {
                question: "faq.question7",
                answer: "faq.answer7",
            },
        ],
        mode: "dark",
    },
    seen: {
        logo: (
            <svg viewBox="0 0 582 196" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M191.418 124.111C191.418 126.805 191.643 129.387 192.316 131.856C192.877 134.101 194 136.009 195.571 137.693C197.142 139.264 199.163 140.387 201.857 141.397C204.551 142.295 207.693 142.744 211.734 142.744C215.775 142.744 220.714 141.509 224.305 139.152C228.009 136.795 229.918 133.091 229.918 127.928C229.918 122.877 229.469 122.989 228.571 120.968C227.673 119.06 226.101 117.264 223.969 115.693C221.836 114.122 219.142 112.662 215.663 111.316C212.183 110.081 207.806 108.622 202.867 107.499C196.02 105.703 190.296 103.795 185.245 101.663C180.306 99.5299 176.153 97.0606 172.898 94.1422C169.643 91.2239 167.173 88.0811 165.602 84.2648C164.031 80.5608 163.245 76.1832 163.245 71.3568C163.245 59.5712 167.398 50.7039 175.704 44.8672C184.01 38.9183 195.459 36 210.05 36C224.642 36 223.183 36.5612 228.795 37.7959C234.52 38.9183 239.458 40.8265 243.611 43.5203C247.764 46.2142 250.907 49.4692 253.377 53.6223C255.734 57.663 256.856 62.714 256.856 68.3262V71.6935H227.448C227.448 65.9691 226.214 61.4793 223.744 58.4487C221.163 55.4182 216.897 53.8467 210.948 53.8467C205 53.8467 204.663 54.2957 202.418 54.9692C200.173 55.8671 198.377 56.7651 196.918 57.9998C195.571 59.2344 194.673 60.6936 194.224 62.4895C193.663 64.1732 193.551 65.9691 193.551 67.6527C193.551 71.3568 194.561 74.4996 196.469 76.8567C198.377 79.3261 202.755 81.6832 209.265 83.8158L232.836 91.8974C238.673 93.8055 243.387 96.0504 246.979 98.183C250.57 100.428 253.713 102.785 255.846 105.142C258.091 107.611 259.55 110.418 260.448 113.448C261.234 116.479 261.683 119.846 261.683 123.55C261.683 136.121 257.081 145.325 247.877 151.05C238.673 156.774 225.765 159.693 209.153 159.693C192.54 159.693 179.632 156.774 172.224 150.713C164.929 144.764 161 136.234 161 125.346V120.52H191.53L191.418 124.111Z"
                    fill="white"
                />
                <path
                    d="M361.468 58.1104H307.366V86.3958H358.325V106.151H307.366V138.365H363.488V158.007H276.836V38.3555H361.468V58.1104Z"
                    fill="white"
                />
                <path
                    d="M463.385 58.1104H409.283V86.3958H460.242V106.151H409.283V138.365H465.517V158.007H378.865V38.3555H463.497L463.385 58.1104Z"
                    fill="white"
                />
                <path
                    d="M553.067 120.406H553.516V38.3555H581.465V157.895H546.669L509.292 74.049H508.843V157.895H480.895V38.3555H516.027L553.067 120.406Z"
                    fill="white"
                />
                <path
                    d="M80.6996 73.6016L84.3996 69.1016C85.7996 67.3016 86.6996 65.0016 86.6996 62.7016V55.6016C86.6996 52.5016 85.2996 49.7016 82.9996 47.8016L40.5996 16.1016L62.5996 8.60156L103.8 42.7016L105.6 70.9016L80.6996 73.6016Z"
                    fill="#D92945"
                />
                <path
                    d="M10.3994 42.5016L54.1994 7.10156L105.699 47.7016L104.099 76.1016L60.7994 74.6016L10.3994 42.5016Z"
                    fill="#EE334B"
                />
                <path
                    d="M8.99961 45.3008L102.8 99.3008V150.401L5.59961 96.0008L8.99961 45.3008Z"
                    fill="#5FC6C9"
                />
                <path
                    d="M102.6 152.899L58.7998 188.299L7.2998 147.599L8.8998 119.199L52.1998 120.799"
                    fill="#F9A825"
                />
                <path
                    d="M30.4994 120.801L26.7994 125.301C25.3994 127.101 24.4994 129.401 24.4994 131.701V138.801C24.4994 141.901 25.8994 144.701 28.1994 146.601L67.3994 178.301L48.5994 185.601L7.19942 151.501L5.39941 123.301L30.4994 120.801Z"
                    fill="#DF8A26"
                />
                <path
                    d="M90.8 69.4H65.9L20.2 43.9L51.2 19.2C53.8 17.1 57.6 17.1 60.3 19.2L95.4 47.2C97.2 48.6 98.1 50.6 98.1 52.9V62.4C98.1 66.2 94.8 69.5 90.8 69.4ZM91.2 99.1C95.6 101.5 98.4 106.3 98.4 111.3V140.1H98.2L71.1 124.9L46.8 111.3L20.8 96.8C16.4 94.4 13.6 89.6 13.6 84.6V55.8L38.1 69.6L62.4 83.2L91.2 99.1C91.2 99.1 91.1 99.1 91.2 99.1ZM51.1 176.5L16.5 148.9C14.6 147.5 13.7 145.3 13.7 142.9V132.6C13.7 128.3 17.1 124.9 21.4 124.9H43.3L91.6 151.8L60.6 176.4C57.9 178.6 53.9 178.6 51.1 176.5ZM111.7 76.3V46.1C111.7 44 110.8 42 109.2 40.8L60 1.5C57.6 -0.5 54 -0.5 51.6 1.5L6.7 37.5L2.5 40.8C1.2 41.9 0.299998 43.3 0.0999985 45C-1.52737e-06 45.5 0 45.9 0 46.3V76.5C0 76.9 -1.52737e-06 77.3 0.0999985 77.7V97.1C0.0999985 99.5 1.5 101.8 3.5 103L14.4 109.1C15.6 109.8 15.1 111.5 13.8 111.5H6.8C3.1 111.5 0 114.6 0 118.3V150.1C0 152.2 0.9 154.2 2.5 155.4L51.6 194.5C52.9 195.5 54.3 195.9 55.9 195.9C57.5 195.9 58.9 195.4 60.2 194.5L105.2 158.7L109.3 155.4C110.8 154.1 111.8 152.1 111.8 150.1V99.3C111.8 96.8 110.4 94.4 108.2 93.2L94.9 85.9C93.7 85.2 94.2 83.5 95.6 83.5H105.1C108.7 83.5 111.9 80.3 111.9 76.7"
                    fill="#1D1D1B"
                />
            </svg>
        ),
        name: "Seen",
        api: "https://api.seentracker.com",
        url: "https://seentracker.com",
        faq: [
            {
                question: "faq.question1",
                answer: "faq.answer1",
            },
            {
                question: "faq.question2",
                answer: "faq.answer2",
            },
            {
                question: "faq.question3",
                answer: "faq.answer3",
            },
            {
                question: "faq.question4",
                answer: "faq.answer4",
            },
            {
                question: "faq.question5",
                answer: "faq.answer5",
            },
            {
                question: "faq.question6",
                answer: "faq.answer6",
            },
            {
                question: "faq.question7",
                answer: "faq.answer7",
            },
        ],
        mode: "dark",
    },
    eva: {
        logo: (
            <svg width="106" height="38" viewBox="0 0 106 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M69.8494 1.79761H60.2363L52.8049 25.8644H52.6685L45.2371 1.79761H35.0786L47.1461 37.0456H57.9182L69.8494 1.79761Z" fill="white"/>
                <path d="M35.1116 21.7736C35.7934 10.9334 29.9983 0.843018 17.999 0.843018C7.29504 0.843018 0 8.88801 0 19.4556C0 30.3641 6.88597 38 17.999 38C25.9758 38 31.7709 34.4547 34.498 26.137H25.9758C25.3622 28.3187 22.226 30.705 18.3399 30.705C12.9538 30.705 9.95398 27.9097 9.68127 21.7736H35.1116ZM9.68127 15.6376C9.81763 12.9105 11.5903 8.13806 17.7263 8.13806C22.4305 8.13806 24.5441 10.7288 25.4304 15.6376H9.68127Z" fill="white"/>
                <path d="M94.1779 36.5816V29.0178C89.1095 29.6016 80.649 30.8743 77.6483 22.5554C76.915 20.5227 76.8503 18.2694 77.4977 16.2078C79.4191 10.0895 84.5549 8.93943 87.2136 9.22064C99.045 10.472 98.4896 21.4169 97.5751 25.8416H104.934C106.892 6.09494 97.3763 2.09451 88.718 1.52173C71.3025 1.52173 68.3645 14.9137 69.0725 21.6097C72.6122 37.8925 87.8064 38.4989 94.1779 36.5816Z" fill="white"/>
                <path d="M97.5753 29.0674H101.33C103.404 29.0674 105.085 30.7484 105.085 32.822C105.085 34.8957 103.404 36.5767 101.33 36.5767C99.2563 36.5767 97.5753 34.8957 97.5753 32.822V29.0674Z" fill="#42AC1C"/>
                <path d="M97.5758 2.45581H105.237V25.8416H97.5758L97.5758 2.45581Z" fill="white"/>
            </svg>
        ),
        name: "Eva",
        api: "https://zealous-berlin-b7cup5iwkv2g.vapor-farm-b1.com",
        url: "https://tracker.evafamily.app",
        faq: [
            {
                question: "faq.question1",
                answer: "faq.answer1",
            },
            {
                question: "faq.question2",
                answer: "faq.answer2",
            },
            {
                question: "faq.question3",
                answer: "faq.answer3",
            },
            {
                question: "faq.question4",
                answer: "faq.answer4",
            },
            {
                question: "faq.question5",
                answer: "faq.answer5",
            },
            {
                question: "faq.question6",
                answer: "faq.answer6",
            },
            {
                question: "faq.question7",
                answer: "faq.answer7",
            },
        ],
        mode: "dark",
    },
};

const getAppConfig = (() => {
    return {
        seen: APP_CONFIGS.seen,
        luna: APP_CONFIGS.luna,
        eva: APP_CONFIGS.eva,
    };
})();

function findStringInURL(str) {
    const currentURL = window.location.href;
    return currentURL.indexOf(str) !== -1;
}

function App() {
    const {setAppName, config, setConfig, appName, isRtl} = useAppContext();
    let {id} = useParams();

    // useEffect(() => {
    //     const isEva = findStringInURL("evafamily.app");
    //     if (!isEva) {
    //         setAppName("luna");
    //         setConfig(getAppConfig.luna);
    //     } else {
    //         setAppName("eva");
    //         setConfig(getAppConfig.eva);
    //     }
    //
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);

    useEffect(() => {
        setAppName("eva");
        setConfig(getAppConfig.eva);
    }, []);

    let logo = config?.logo;
    let mode = config?.mode;
    let faq = config?.faq;

    const darkTheme = createTheme({
        palette: {
            mode: mode,
        },
    });
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>{t("qr.title", {appName})}</title>
                <meta name="description" content={t("qr.meta", {appName})}/>
            </Helmet>
            <InitializePusher id={id}/>
            <ThemeProvider theme={darkTheme}>
                <CssBaseline/>
                <Favicon
                    url={appName === "eva" ? "/eva/favicon.ico" : "/favicon.ico"}
                />
                <div className={`App ${isRtl ? "rtl" : ""}`}>
                    <div>
                        <header className="AppHeader">
                            <Header logo={logo}/>
                        </header>
                        <main>
                            <div className="container">
                                <QR/>
                                <div className="row mt-5 mb-5">
                                    <div className="col-12">{faq && <FAQ data={faq}/>}</div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </ThemeProvider>
        </>
    );
}

export default App;
